import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TWarranty } from './models';
import { ShieldIcon } from './icons/shield-icon';

export const Warranty: FC<TWarranty> = ({
    Block,
    Text,
    content = 'Мы гарантируем безопасность и сохранность ваших данных',
    styles,
}) => (
    <Block className={cn(styles.external, styles.wrapper)} notPadded>
        <div className={styles.security}>
            <ShieldIcon />
            <Text
                kind="caption"
                styler={{ marginTop: 0, marginBottom: 0, marginLeft: 16 }}
                view="component-secondary"
            >
                {content}
            </Text>
        </div>
    </Block>
);
